import i18next from "i18next";
import * as Setting from "../conf/Setting";

const {fetch: originalFetch} = window;
window.fetch = async(...args) => {
  const [resource, config] = args;
  const response = await originalFetch(resource, config);
  if (config.responseType !== "blob") {
    const json = await response.clone().json();
    if (json?.msg === "Please login first") {
      Setting.showMessage("error", i18next.t("account:Login info expired"));
      Setting.clearSession();
      Setting.goToLink("/login");
      return response;
    }
  }

  return response;
};
